import { categoryDataServicee } from "./services";
import { ItemPage, LibraryCard } from "./components";
import {
  AddButton,
  BackButton,
  CancelButton,
  DeleteButton,
  EditButton,
  SaveButton,
} from "./components/toolbar-items";
import { faListSquares } from "@fortawesome/free-solid-svg-icons";
import { ModuleTypeEnum } from "../../enums";
import { IModuleConfig } from "../../interfaces";

const config: IModuleConfig = {
  id: "categories",
  name: "Categories",
  icon: faListSquares,
  moduleType: ModuleTypeEnum.DualPaneLibrary,
  allowSearch: true,
  services: {
    getByPage: categoryDataServicee.getByPage,
    getSingle: categoryDataServicee.getSingle,
    search: categoryDataServicee.search,
    create: categoryDataServicee.create,
    update: categoryDataServicee.update,
    delete: categoryDataServicee.delete,
  },
  components: {
    libraryCard: LibraryCard,
    itemPage: ItemPage,
  },
  utilities: {
    extractKey: (d: any) => d.id,
    extractItemPath: (d: any) => d.id,
    extractItemBreadcrumb: (d: any) => `${d.department}`,
  },
  // Add toolbar items in order they should render in the toolbar
  toolbarItems: {
    library: [AddButton],
    view: [BackButton, "|", EditButton, DeleteButton],
    edit: [SaveButton, CancelButton],
    create: [],
  },
};

export default config;
